import React, { useContext, useEffect, useState } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from '../../../../User/Avatar';
import { CommentContext } from '../../../CommentContext';
import CommentFooter from '../../../lego/CommentFooter';
import ReplyCommentBox from '../../../lego/ReplyCommentBox';
import ReadContentBlock from '../../../lego/ReadContentBlock';
import RootLayout from './RootLayout';
import s from './ReadView.scss';
function useMomentaryHighlightOnMount(shouldHighlight) {
    var isMounted = useIsMounted();
    var _a = useState(shouldHighlight), isHighlighted = _a[0], setIsHighlighted = _a[1];
    useEffect(function () {
        if (typeof window !== 'undefined' && shouldHighlight && !isMounted) {
            /* eslint-disable @wix/da/window-object-typeof-check */
            var timeout = window.setTimeout(function () { return setIsHighlighted(false); });
            return window.clearTimeout(timeout);
            /* eslint-enable @wix/da/window-object-typeof-check */
        }
    }, [shouldHighlight, isMounted]);
    return isHighlighted;
}
/**
 * The read view for our standard comment preset. Includes a utility prop to highlight the comment on mount. Otherwise, standard fare.
 */
var ReadView = function (_a) {
    var highlightOnMount = _a.highlightOnMount, canPostComment = _a.canPostComment, nc = _a.nc, _b = _a.includeFooter, includeFooter = _b === void 0 ? true : _b, onReplyPosted = _a.onReplyPosted;
    var isMobile = useContext(MobileContext);
    var _c = useContext(CommentContext), comment = _c.comment, isReplying = _c.isReplying;
    var isHighlighted = useMomentaryHighlightOnMount(highlightOnMount);
    var user = comment.user;
    var canReply = !comment.isHidden && !comment.isSpam;
    return (React.createElement(RootLayout, { prefix: user && (React.createElement(UserAvatar, { user: user, size: isMobile ? 24 : 32, className: s['avatar'], withTooltip: true })), contentBlocks: [
            React.createElement(ReadContentBlock, { key: "main-content", isHighlighted: isHighlighted }),
            includeFooter && (React.createElement(CommentFooter, { key: "footer", className: s['footer'], canPostComment: canPostComment })),
            isReplying && canReply && (React.createElement(ReplyCommentBox, { key: "reply", nc: nc, className: s['reply-block'], onReplyPosted: onReplyPosted, canPostComment: canPostComment })),
        ] }));
};
ReadView.displayName = 'ReadView';
export default ReadView;
//# sourceMappingURL=ReadView.js.map